import {IInvestStoreService} from "./IInvestStoreService";
import {UserStripeService} from "../../../stripe/service/UserStripeService";
import {StoreViewStore} from "../../common/services/StoreViewStore";
import {IInvestStoreProduct} from "../models/IInvestStoreProduct";

export class IInvestStoreViewStore extends StoreViewStore<IInvestStoreProduct> {

    private constructor(service: IInvestStoreService, userStripeService: UserStripeService) {
        super(service, userStripeService);
    }

    public togglePlatformState() {
        this.toggleProductState(IInvestStoreProduct.PLATFORM);
    }

    public static initialize(storeService: IInvestStoreService,
                             userStripeService: UserStripeService): IInvestStoreViewStore {
        return new IInvestStoreViewStore(storeService, userStripeService);
    }
}
